
export default {
  name: 'MoleculeTeam'
}
